import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/guide/page";
import HowToUsePage from "../pages/how-to-use/page";
import ShippingPage from "../pages/shipping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-sheet-guide",
    element: <GuidePage />,
  },
  {
    path: "/how-to-use-superbuy-sheet",
    element: <HowToUsePage />,
  },
  {
    path: "/superbuy-shipping-strategy-guide",
    element: <ShippingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;